import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetInputSuggestionsQueryVariables = Types.Exact<{
  type: Types.Scalars['String']['input'];
}>;


export type GetInputSuggestionsQuery = { __typename?: 'query_root', input_suggestions: Array<{ __typename?: 'input_suggestions', id: any, text: string, type?: string | null }> };


export const GetInputSuggestionsDocument = gql`
    query getInputSuggestions($type: String!) {
  input_suggestions(where: {type: {_eq: $type}}) {
    id
    text
    type
  }
}
    `;

/**
 * __useGetInputSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetInputSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInputSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInputSuggestionsQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetInputSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<GetInputSuggestionsQuery, GetInputSuggestionsQueryVariables> & ({ variables: GetInputSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInputSuggestionsQuery, GetInputSuggestionsQueryVariables>(GetInputSuggestionsDocument, options);
      }
export function useGetInputSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInputSuggestionsQuery, GetInputSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInputSuggestionsQuery, GetInputSuggestionsQueryVariables>(GetInputSuggestionsDocument, options);
        }
export function useGetInputSuggestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInputSuggestionsQuery, GetInputSuggestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInputSuggestionsQuery, GetInputSuggestionsQueryVariables>(GetInputSuggestionsDocument, options);
        }
export type GetInputSuggestionsQueryHookResult = ReturnType<typeof useGetInputSuggestionsQuery>;
export type GetInputSuggestionsLazyQueryHookResult = ReturnType<typeof useGetInputSuggestionsLazyQuery>;
export type GetInputSuggestionsSuspenseQueryHookResult = ReturnType<typeof useGetInputSuggestionsSuspenseQuery>;
export type GetInputSuggestionsQueryResult = Apollo.QueryResult<GetInputSuggestionsQuery, GetInputSuggestionsQueryVariables>;